export default "__VITE_ASSET__f57b4094__"